import { OrderStatus } from '@alberta/konexi-shared';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'orderStatusPipe',
  standalone: false,
})
export class OrderStatusPipe implements PipeTransform {
  constructor(private _translate: TranslateService) {}

  transform(item: OrderStatus): string {
    return this._translate.instant(`order.status.${item}`);
  }
}
